var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89028 30.3569H23.1131C25.8857 30.3569 27.2651 28.9643 27.2651 26.1649V5.84772C27.2651 3.06201 25.8857 1.64258 23.1131 1.64258H8.89028C6.13142 1.64258 4.73828 3.06201 4.73828 5.84829V26.1649C4.73828 28.9637 6.13142 30.3569 8.89028 30.3569ZM8.99714 28.2009C7.61771 28.2009 6.89428 27.4637 6.89428 26.1249V5.88829C6.89428 4.56258 7.61771 3.79858 9.01085 3.79858H23.0063C24.3989 3.79858 25.1091 4.54886 25.1091 5.88829V26.1249C25.1091 27.4637 24.3989 28.2009 23.0194 28.2009H8.99714ZM10.9394 9.39686H21.0909C21.5594 9.39686 21.9211 9.02201 21.9211 8.55344C21.9211 8.09801 21.56 7.75001 21.0909 7.75001H10.9394C10.4434 7.75001 10.0954 8.09801 10.0954 8.55344C10.0954 9.02201 10.444 9.39686 10.9394 9.39686ZM10.9394 14.0711H21.0909C21.5594 14.0711 21.9211 13.6963 21.9211 13.2272C21.9211 12.7723 21.56 12.4237 21.0909 12.4237H10.9394C10.4434 12.4237 10.0954 12.7723 10.0954 13.2272C10.0954 13.6957 10.444 14.0711 10.9394 14.0711ZM10.9394 18.7454H15.7474C16.216 18.7454 16.5777 18.3837 16.5777 17.9283C16.5777 17.4597 16.216 17.098 15.7474 17.098H10.9389C10.4429 17.098 10.0949 17.4597 10.0949 17.9283C10.0949 18.3837 10.4434 18.7454 10.9389 18.7454",
    fill: "#151D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.25841b6b473249d56bc85d4af639f0a7.svg";
export { ForwardRef as ReactComponent };